<div class="dialog">

    <mat-toolbar color='primary' mat-dialog-title fxLayoutAlign="space-between">
        <h2 style='margin-top:3px;'>
            Profile
        </h2>

        <button class="button-close" mat-raised-button mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>

    <mat-tab-group id='tabs'>
        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon class='tab-icon'>fingerprint</mat-icon>
                Password
            </ng-template>

            <form class="form" name="accountForm" [formGroup]='accountForm' autocomplete="off">

                <div class='container'>

                    <div class='account-panel'>

                        <mat-form-field class="full-width">
                            <input matInput type="password" [errorStateMatcher]="matcher"
                                [formControl]="accountForm.controls.password" placeholder="Senha" autocomplete="off">
                            <mat-error *ngIf="accountForm.controls.password.hasError('required')">
                                Senha é obrigatório
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="full-width">
                            <input matInput type="password" [errorStateMatcher]="matcher"
                                [formControl]="accountForm.controls.confirm" placeholder="Confirma" autocomplete="off">
                            <mat-error *ngIf="accountForm.controls.confirm.hasError('required')">
                                Confirmação é obrigatória
                            </mat-error>
                            <mat-error *ngIf="accountForm.controls.confirm.hasError('mustMatch')">
                                Senha e confirmação devem ser iguais.
                            </mat-error>
                        </mat-form-field>


                    </div>

                    <div class="action-tab" fxLayoutAlign="end" flex justify-content='flex-end'>
                        <div [ngClass]="{hidden: !spinner}">
                            <mat-spinner diameter="30"></mat-spinner>
                        </div>

                        <button mat-raised-button (click)='update()' [disabled]="accountForm.invalid">
                            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
                        </button>

                    </div>

                </div>

            </form>

        </mat-tab>

    </mat-tab-group>


</div>
